import CookiebotProvider from './CookiebotProvider';

export default CookiebotProvider;
